import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import './ServicesSection.css';

const servicesData = [
  {
    category: 'HAIR CUT',
    services: [
      'Stylist',
      'Senior Stylist',
      'Style Director',
      'Shave',
      'Beard Trim',
    ],
  },
  {
    category: 'HAIR TREATMENT',
    services: [
      'Deep Conditioning',
      'Hair Spa',
      'Drandruff Treatment',
      'Anti Hairlost Treatment',
      'Hair Spa (Moroccan)',
      'Fiber Clinix',
      'fibre Plex',
    ],
  },
  {
    category: 'HAIR TEXTURE',
    services: [
      'Straightening',
      'Smoothening',
      'Keratin',
      'Botox Treatment',
      'Nanoplastia',
      'Hair Perming',
      'Perminent Blowdry',
      'Rebonding',
    ],
  },
  {
    category: 'COLOR',
    services: [
      'Highlights Per Streaks',
      'Beard moustache (With Ammonia)',
      'Beard moustache (Ammonia Free)',
      'Hair Colour (With Ammonia)',
      'Hair Colour (Ammonia Free)',
      'Global',
      'Corrective Colour',
    ],
  },
  {
    category: 'STYLING',
    services: [
      'Hair Wash & Conditioning',
      'Wash & BlowDry',
      'Ironing',
      'Tongs',
    ],
  },
  {
    category: 'MASSAGE',
    services: [
      'Head Massage',
      'Foot Massage Body Polish',
    ],
  },
  {
    category: 'PIERCING',
    services: [
      'Gun Shot',
      'Mole Removal',
    ],
  },
  {
    category: 'D TAN PACKS',
    services: [
      'D-Tan Packs (Face)',
      'D-Tan Pack (Face, Neck)',
      'D-Tan Pack (Face, Neck, Back)',
      'D-Tan Back',
      'D Tan Stomach',
      'Full Arms',
      'Half Arms',
      'Full Legs',
      'Half Legs',
      'O3 Tan Pack (Face)',
      'O3 Tan Pack (Face, Neck)',
      'O3 Tan Pack (Face, Neck, Back)',
      'Gold Pack (Face)',
      'Glow Pack (Face)',
    ],
  },
  {
    category: 'CLEAN-UP',
    services: [
      'Fruit Clean-up',
      'Pearl Clean-up',
      'Gold Clean-up',
      'Diamond Clean-up',
      'Wine Clean-up',
      'O`3 Clean-up',
    ],
  },
  {
    category: 'FACIALS',
    services: [
      'Fruit Facial',
      'Hydra Facial',
      'Silver facial',
      'Tan Clear Facial',
      'Wine Facial',
      'Whitening Facial',
      'Anti Aging Facial',
    ],
  },
  {
    category: 'LUXURY FACIALS',
    services: [
      'Gold Facial',
      'Diamond Facial',
      'Seasoul Facials',
      'Pro Hydra Facial',
      'Aroma Magic Pro',
      'Pro Anti Aging Facial',
      'O’3 Bridal Facial',
      'Oxygeneo Facial',
      'BB Glow',
      'korian glass facial',
    ],
  },
  {
    category: 'PEDICURE',
    services: [
      'Pedicure (Basic)',
      'Spa Pedicure',
      'Dtan Pedicure',
      'Crystal Pedicure',
      'Ice Cream Pedicure',
      'Heel Peel Treatment',
    ],
  },
  {
    category: 'MANICURE',
    services: [
      'Manicure (Basic)',
      'Spa Manicure',
      'D tan Manicure',
      'Crystal Manicure',
      'Ice Cream Manicure',
    ],
  },
  {
    category: 'NAILS',
    services: [
      'Cut & File',
      'Change Of Polish',
      'French Polish',
      'Basic Extensions',
      'gel polish',
    ],
  },
  {
    category: 'THREADING',
    services: [
      'Eyebrows',
      'Upper Lip',
      'Forhead Chin',
      'Full Face',
    ],
  },
  {
    category: 'WAXING',
    services: [
      'Chin',
      'Upper Lip',
      'Neck',
      'Side Face',
      'Full Face',
      'Under Arms',
      'Half Arms',
      'Full Arms',
      'Half Legs',
      'Full Legs',
      'Half Back',
      'Full Back',
      'Stomach',
      'Full Front',
      'Bikini',
      'Full Body',
    ],
  },
  {
    category: 'MAKEUP (in salon)',
    services: [
      'Party Makeup',
      'Natural Makeup',
      'Water Proof Makeup',
      'HD Makeup',
      'Air Brush Makeup',
      'Hair Styling',
      'Saree Draping',
      'Saree Box Folding',
    ],
  },
  {
    category: 'ALL OUR PACKAGE INCLUDES SAREE DRAPING, HAIRSETTING, MAKEUP',
    services: [],
  },
  {
    category: 'BRIDAL PACKAGE(OUT DOOR)',
    services: [
      'Groom makeup',
      'Bridal Makeup',
    ],
  },
];

const containerVariants = {
  hidden: { opacity: 0, y: 30 },
  visible: { opacity: 1, y: 0, transition: { staggerChildren: 0.15 } },
};

const itemVariants = {
  hidden: { opacity: 0, y: 20 },
  visible: { opacity: 1, y: 0 },
};

const ServicesSection = ({ showH1 = false }) => {
  const [expandedIndex, setExpandedIndex] = useState(null);

  useEffect(() => {
    document.title = 'Hair and beauty services in Visakhapatnam | Celebrity Cuts';
    const metaDesc = document.querySelector('meta[name="description"]');
    if (metaDesc) metaDesc.setAttribute('content', 'Looking for expert hair and beauty services in Visakhapatnam? Celebrity Cuts offers professional styling, skincare, and grooming solutions for men and women.');
  }, []);

  const toggleExpand = (index) => {
    setExpandedIndex(expandedIndex === index ? null : index);
  };

  return (
    <section className="services-section">
      <div className="container">
        {showH1 && (
          <>
            <h1 className="section-title centered-title">Professional Hair and Beauty Services in Visakhapatnam</h1>
            <p className="services-intro">At Celebrity Cuts, we offer professional hair and beauty services in Visakhapatnam to enhance your style and confidence. Our expert stylists provide personalized care in a hygienic and relaxing environment.</p>
          </>
        )}
        <div className="services-layout">
          <div className="services-columns">
            {[0, 1].map((colIndex) => {
              const filteredServicesData = servicesData.filter(
                (category) => category.category !== 'ALL OUR PACKAGE INCLUDES SAREE DRAPING, HAIRSETTING, MAKEUP'
              );
              const half = Math.floor(filteredServicesData.length / 2);
              const start = colIndex === 0 ? 0 : half;
              const end = colIndex === 0 ? half : filteredServicesData.length;
              const columnData = filteredServicesData.slice(start, end);
              return (
                <motion.div
                  key={colIndex}
                  className="services-column"
                  variants={containerVariants}
                  initial="hidden"
                  animate="visible"
                >
                  {columnData.map((category, index) => {
                    const globalIndex = start + index;
                    return (
                      <motion.div
                        key={category.category}
                        className="service-section"
                        variants={itemVariants}
                      >
                        <h3
                          className="service-heading"
                          onClick={() => toggleExpand(globalIndex)}
                          aria-expanded={expandedIndex === globalIndex}
                          role="button"
                          tabIndex={0}
                          onKeyDown={(e) => {
                            if (e.key === 'Enter' || e.key === ' ') toggleExpand(globalIndex);
                          }}
                        >
                          {category.category}
                          <span className="accordion-icon">
                            +
                          </span>
                        </h3>
                        <AnimatePresence>
                          {expandedIndex === globalIndex && (
                            <motion.ul
                              className="service-list"
                              initial={{ opacity: 0, height: 0 }}
                              animate={{ opacity: 1, height: 'auto' }}
                              exit={{ opacity: 0, height: 0 }}
                              transition={{ duration: 0.4 }}
                            >
                              {category.services.map((service, idx) => (
                                <motion.li
                                  key={service}
                                  className="service-list-item"
                                  initial={{ opacity: 0, y: 10 }}
                                  animate={{ opacity: 1, y: 0 }}
                                  transition={{ delay: idx * 0.1, duration: 0.3 }}
                                >
                                  {service}
                                </motion.li>
                              ))}
                            </motion.ul>
                          )}
                        </AnimatePresence>
                      </motion.div>
                    );
                  })}
                </motion.div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};

export default ServicesSection;
